import { sdkLogger } from '../../logger/logger';
import type { AnswerValue } from '../../submitSurvey/types';
import type { SdkLoggableError } from '../../types/shared';

export function logChangeAnswer(questionId: string, value: AnswerValue): void {
  sdkLogger.info(`Answer changed for question: ${questionId}`, { value });
}

export function logScrollWarning(msg: string, err: SdkLoggableError): void {
  sdkLogger.warn(msg, { err });
}

export function logSubmitInitiated(): void {
  sdkLogger.info('Initiating survey submission...');
}

export function logBackNavigation(currentIndex: number): void {
  sdkLogger.info(`Navigating back from page index: ${currentIndex}`);
}

export function logNextNavigation(currentIndex: number): void {
  sdkLogger.info(`Navigating next from page index: ${currentIndex}`);
}

export function logPaginationSubmitError(err: SdkLoggableError): void {
  sdkLogger.error('Error encountered during pagination submit trigger', { err });
}
